import { FC } from "react";
import { Stat } from "./types";
import MembershipHeroDesktop from "./MembershipHeroDesktop";
import MembershipHeroMobile from "./MembershipHeroMobile";

interface MembershipHeroProps {
  label: string;
  title: string;
  stats: Stat[];
  heroImage: string;
  heroImageMobile?: string;
  isDark: boolean;
  bgClass: string;
  textClass: string;
}

const MembershipHero: FC<MembershipHeroProps> = ({
  label,
  title,
  stats,
  heroImage,
  heroImageMobile,
  isDark,
  bgClass,
  textClass,
}) => {
  return (
    <>
      <div className="md:hidden">
        <MembershipHeroMobile
          label={label}
          title={title}
          stats={stats}
          heroImage={heroImageMobile ?? heroImage}
          isDark={isDark}
          bgClass={bgClass}
          textClass={textClass}
        />
      </div>
      <div className="hidden md:block">
        <MembershipHeroDesktop
          label={label}
          title={title}
          stats={stats}
          heroImage={heroImage}
          isDark={isDark}
          bgClass={bgClass}
          textClass={textClass}
        />
      </div>
    </>
  );
};

export default MembershipHero;
